const types = [
  {
    title: "Manuel",
    desc: "Commande par sangle, manivelle ou treuil. Solution simple, économique et fiable. Idéal pour les petites ouvertures et les budgets serrés.",
    icon: "ri-hand-coin-line",
  },
  {
    title: "Électrique filaire",
    desc: "Commande par interrupteur mural ou point de commande. Connexion directe au réseau électrique. Confort et fiabilité au quotidien.",
    icon: "ri-plug-line",
  },
  {
    title: "Électrique radio",
    desc: "Commande par télécommande ou smartphone, sans fils apparents. Compatible Somfy, Nice, Simu. Installation rapide et moderne.",
    icon: "ri-remote-control-line",
  },
  {
    title: "Solaire",
    desc: "Motorisation autonome alimentée par un panneau solaire intégré. Sans câblage, sans travaux électriques. Écologique et économique.",
    icon: "ri-sun-line",
  },
];

export default function Types() {
  return (
    <section className="bg-white py-14 md:py-20">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <h2 className="text-brand-blue text-2xl md:text-3xl font-extrabold text-center mb-3">
          Manuel, électrique ou solaire
        </h2>
        <p className="text-brand-text text-base text-center mb-10 md:mb-14 max-w-2xl mx-auto">
          Quatre modes de commande pour s'adapter à votre budget, votre confort et votre projet de rénovation ou de construction.
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {types.map((t) => (
            <div key={t.title} className="bg-white rounded-xl border border-brand-border p-5 md:p-6">
              <div className="w-11 h-11 flex items-center justify-center rounded-full bg-brand-cyan/10 mb-4">
                <i className={`${t.icon} text-brand-cyan text-lg`}></i>
              </div>
              <h3 className="text-brand-blue text-base font-bold mb-2">{t.title}</h3>
              <p className="text-brand-text text-sm leading-relaxed">{t.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}